<section *ngIf="partner">
  <div class="content-wrapper partner-banner">
    <h1>{{ partner.banner_title }}</h1>
    <div class="partner-logo-container">
      <h1 class="howden">Howden for Students</h1>
      <div>
        <img [src]="partner.partner?.data?.attributes?.url" />
      </div>
    </div>
    <div (click)="trackEvent()">
      <a
        [routerLink]="partner.web_route"
        [queryParams]="{source}"
        class="button"
      >
        {{ partner.banner_button_text }}
      </a>
    </div>
  </div>
</section>
